<template>
  <b-modal :id="idModal" centered :title="titleModal" :size="sizeModal">
    <b-container fluid>
      <slot></slot>
    </b-container>
    <template #modal-footer="{ hide }">
      <b-button
        size="sm"
        @click="close(hide)"
        class="float-right"
        :disabled="disableButtons"
      >
        {{ closeButtonName }}
      </b-button>

      <b-button
        variant="primary"
        size="sm"
        class="float-right"
        @click="submit(hide)"
        :disabled="disableButtons"
      >
        {{ submitButtonName }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    idModal: {
      type: String,
      default: "modal-center",
    },
    titleModal: {
      type: String,
      default: "Modal default",
    },
    sizeModal: {
      type: String,
      default: "lg",
    },
    disableButtons: {
      type: Boolean,
      default: false,
    },
    closeButtonName: {
      type: String,
      default: "Fechar",
    },
    submitButtonName: {
      type: String,
      default: "Salvar",
    },
  },
  methods: {
    close(hide) {
      this.$emit("close", hide);
    },
    submit(hide) {
      this.$emit("submit", hide);
    },
  },
};
</script>
